export class SetValid {
    answer: boolean;
}